import {
  getTeamName,
  getGameResult,
  getGameStatus,
  getDate,
  removeUndefinedPropertiesFromObject,
  LinkCreationService,
} from '@sportal365/smp-widget-utils';
import { IFootballConfig, IMatchH2H, INormalizedFootballGameData, SDKDateOptions, WinnerReason } from '../../../../packages/types';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';
import { TEAM_ENTITY } from '../../../../packages/constants/entityTypes';
import { assetsPlaceholder } from '../../../../packages/constants/assetsPlaceholder';

interface INormalizeFootballMatchesH2HGameData {
  game?: IMatchH2H;
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
  dataTeamNameType?: IFootballConfig['dataTeamNameType'];
  dataShortStatusType?: IFootballConfig['dataShortStatusType'];
  sdkDateOptions?: SDKDateOptions;
}

export const normalizeFootballMatchesH2HGameData = ({
  game,
  dataEntityLinks,
  dataShortStatusType,
  dataTeamNameType,
  sdkDateOptions,
}: INormalizeFootballMatchesH2HGameData) => {
  if (!game) return;

  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  let target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;
  target = game.homeTeam.type === 'placeholder' && game.homeTeam.type === game.awayTeam.type ? TARGET_SELF : target;
  const matchLink = linkService?.createMatchUrl(game.id, game?.homeTeam, game?.awayTeam, game?.slug ?? '') ?? '#';

  const winnerId = game.winner?.match?.id;
  const winnerReason = (game.winner?.aggregate?.reason?.name as WinnerReason) ?? null;
  const aggregateWinnerId = game.winner?.aggregate?.id ?? '';

  return removeUndefinedPropertiesFromObject<INormalizedFootballGameData>({
    id: game.id,
    homeTeam: {
      name: getTeamName(game.homeTeam, dataTeamNameType),
      logo: game?.homeTeam?.assets?.logo?.url ? game?.homeTeam?.assets?.logo?.url : assetsPlaceholder.team,
      id: game.homeTeam.id,
      url: linkService?.createEntityUrl(String(game.homeTeam.id), TEAM_ENTITY, game.homeTeam.type ?? '', game.homeTeam.slug) ?? '#',
      type: game?.homeTeam?.type || '',
    },
    awayTeam: {
      name: getTeamName(game.awayTeam, dataTeamNameType),
      logo: game?.awayTeam?.assets?.logo?.url ? game.awayTeam.assets.logo.url : assetsPlaceholder.team,
      id: game.awayTeam.id,
      url: linkService?.createEntityUrl(String(game.awayTeam.id), TEAM_ENTITY, game.awayTeam.type ?? '', game.awayTeam.slug) ?? '#',
      type: game?.awayTeam?.type || '',
    },
    date: (game?.kickoffTime && getDate(game?.kickoffTime, sdkDateOptions)) || undefined,
    status: getGameStatus(game, dataShortStatusType, sdkDateOptions),
    homeTeamScore: getGameResult(game.status?.type, game.score?.display?.home),
    awayTeamScore: getGameResult(game.status?.type, game.score?.display?.away),
    matchStatus: game.status,
    kickOffTime: game.kickoffTime ? new Date(game.kickoffTime) : undefined,
    minute: game.minute,
    matchLink,
    urlTarget: target,
    winnerId: winnerId,
    aggregateWinnerId,
    winnerReason: winnerReason,
  });
};
